/**
 * Generates lighter and darker shades of a given primary hex color.
 * Produces a set of shades by adjusting RGB values and clamping results to [0, 255].
 * @param primary600 - The base hex color (e.g., `#336699`).
 * @returns An object with generated shades `{ primary100, primary200, primary300, primary500, primary700 }`.
 */
export const generateColorShades = (primary600: string) => {
  const hexToRGB = (hex: string) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return { r, g, b };
  };

  const rgbToHex = (r: number, g: number, b: number) => {
    return `#${Math.round(r).toString(16).padStart(2, '0')}${Math.round(g).toString(16).padStart(2, '0')}${Math.round(b).toString(16).padStart(2, '0')}`;
  };

  const clamp = (value: number) => Math.max(0, Math.min(255, value));

  const { r, g, b } = hexToRGB(primary600);

  return {
    primary100: rgbToHex(clamp(r + 180), clamp(g + 180), clamp(b + 180)),
    primary200: rgbToHex(clamp(r + 160), clamp(g + 160), clamp(b + 160)),
    primary300: rgbToHex(clamp(r + 100), clamp(g + 100), clamp(b + 100)),
    primary500: rgbToHex(clamp(r + 40), clamp(g + 40), clamp(b + 40)),
    primary700: rgbToHex(clamp(r - 20), clamp(g - 20), clamp(b - 20)),
  };
};
